import script from "./SaveAuthModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveAuthModal.vue?vue&type=script&setup=true&lang=js"

import "./SaveAuthModal.vue?vue&type=style&index=0&id=d8ac494a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ac494a"]])

export default __exports__